// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loadingContainer-fYi83{display:flex;align-items:center;justify-content:center;height:100px}`, "",{"version":3,"sources":["webpack://./src/components/events/EventsScrollLoading/eventsScrollLoading.module.scss"],"names":[],"mappings":"AAAA,wBACI,YAAA,CACA,kBAAA,CACA,sBAAA,CACA,YAAA","sourcesContent":[".loadingContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": `loadingContainer-fYi83`
};
export default ___CSS_LOADER_EXPORT___;
